import * as z from 'zod';

import { EventId, LedgerTransactionId } from '../../BrandedIds';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';
import { Posting } from './Posting';

// Atomic recording group — postings sharing one effectiveDate,
// recordedAt, and eventId. Business-event metadata lives in the
// events table, joined via `eventId`. Branded `LedgerTransactionId`
// (not `TransactionId`) to avoid colliding with the pre-existing
// brand used elsewhere.
export const Transaction = z.object({
  id: LedgerTransactionId,
  eventId: EventId,
  effectiveDate: zodTemporalPlainDate,
  recordedAt: zodTemporalInstant,
  postings: z.array(Posting).nonempty(),
});
export type Transaction = z.infer<typeof Transaction>;
